@if (assetsLayerGroup) {
  <div>
    @if (element.path) {
      <sis-map-element-curve
        [attr.data-test]="curveTestClass"
        [assetsLayerGroup]="assetsLayerGroup"
        [element]="element"
        [showStatus]="showStatus"
        [editMode]="editMode"
      ></sis-map-element-curve>
    }
    @if (!element.iconUseStatus || showSlopeLabels) {
      @for (icon of element.iconPositions; track icon; let i = $index) {
        <sis-map-element-icon
          [attr.data-test]="iconTestClass"
          [assetsLayerGroup]="assetsLayerGroup"
          [element]="element"
          [showStatus]="showStatus"
          [positionIndex]="i"
          [editMode]="editMode"
        ></sis-map-element-icon>
      }
    }
  </div>
}
